import React, { useEffect, useState } from 'react';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import StopIcon from '@mui/icons-material/Stop';
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';
import * as S from './styled';

export default function AudioRecorder({
	// caso grave um novo audio
	audioRecorderFile = null,
	setAudioRecorderFile = () => {},

	// se caso tiver audio da api
	audioByMonitoring = null,
	setAudioByMonitoring = () => {}
}) {
	const [isRecording, setIsRecording] = useState(false);

	const [audioData, setAudioData] = useState(null);
	const [mediaRecorder, setMediaRecorder] = useState(null);
	const ffmpeg = new FFmpeg();

	useEffect(() => {
		if (!ffmpeg.loaded) {
			ffmpeg.load();
		}
	}, [ffmpeg]);

	async function convertToM4A(blob) {
		if (!ffmpeg.loaded) await ffmpeg.load();

		// Carrega o arquivo WebM para o ffmpeg
		await ffmpeg.writeFile('recording.webm', await fetchFile(blob));

		// Converte o arquivo para M4A
		await ffmpeg.exec(['-i', 'recording.webm', 'recording.m4a']);

		// Lê o arquivo convertido e cria um File para ser usado no áudio
		const data = await ffmpeg.readFile('recording.m4a');
		const file = new File([data.buffer], 'recording.m4a', { type: 'audio/m4a' });

		setAudioRecorderFile(file); // Define o File para setAudioRecorderFile
	}

	function start() {
		navigator.mediaDevices
			.getUserMedia({ audio: true })
			.then((stream) => {
				const recorder = new MediaRecorder(stream, {
					mimeType: 'audio/webm', // Usando audio/webm como MIME type
					audioBitsPerSecond: 128000 // Ajuste a taxa de bits se necessário
				});

				recorder.ondataavailable = async (event) => {
					if (event.data.size > 0) {
						const blob = event.data;

						// Cria um arquivo a partir do blob
						const file = new File([blob], 'recording.webm', { type: 'audio/webm' });

						// Armazena o áudio original em `setAudioData` para reprodução
						setAudioData({
							uri: URL.createObjectURL(file),
							name: file.name,
							type: file.type
						});

						// Converte para M4A
						await convertToM4A(blob);
					}
				};

				// Limpa o estado de áudio antes de iniciar a gravação
				setAudioData(null);

				recorder.start();

				setMediaRecorder(recorder);
				setIsRecording(true);
				setAudioRecorderFile(null);
				setAudioByMonitoring({});
			})
			.catch((err) => {
				console.error('Erro ao acessar o microfone:', err);
			});
	}

	function stop() {
		if (mediaRecorder) {
			mediaRecorder.stop();
			setIsRecording(false);
		}
	}

	useEffect(
		() => () => {
			if (audioData && audioData.uri) {
				URL.revokeObjectURL(audioData.uri);
			}
		},
		[audioData]
	);

	return (
		<S.containerRecorder>
			<S.btnRecorder>
				<button
					type="button"
					onClick={() => {
						if (!isRecording) {
							start();
						} else {
							stop();
						}
					}}
				>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}
					>
						{!isRecording ? (
							<>
								<RecordVoiceOverIcon style={{ width: 22 }} sx={{ mr: 1 }} /> Gravar
							</>
						) : (
							<>
								<StopIcon sx={{ mr: 1 }} /> Parar
							</>
						)}
					</div>
				</button>

				{audioRecorderFile === null && isRecording ? <S.animationRecorder>Gravando...</S.animationRecorder> : null}
			</S.btnRecorder>
			{audioData && audioData?.uri ? (
				<audio controls>
					<source src={audioData.uri} type={audioData.type} />
					<track src={audioData.uri} kind="captions" srcLang="pt" label="Alerta Clima Indígena (ACI)" />
					Seu navegador não suporta o elemento de áudio.
				</audio>
			) : null}

			{audioByMonitoring?.uri && audioRecorderFile === null ? (
				<audio controls>
					<source src={audioByMonitoring.uri} type="audio/mp4" />
					<track src={audioByMonitoring.uri} kind="captions" srcLang="pt" label="Alerta Clima Indígena (ACI)" />
					Seu navegador não suporta o elemento de áudio.
				</audio>
			) : null}
		</S.containerRecorder>
	);
}
